import React from 'react';
import ReactDOM from 'react-dom';
import App from "./App";
import './core/i18n/i18n'

import './index.css';
import './core/style/soft-theme.css';
import { LocalStorageService } from "./core/service/local-storage-service";

const init = async (module) => {
    localStorage.setItem('recording', 'false');
    const config = window.AppSettings
    const lang = LocalStorageService.getLanguage('tr')
    document?.querySelector('meta[name="description"]')?.setAttribute('content', config[module].description[lang]);
    document.title = config[module].title[lang];

    document.querySelector('link[rel="icon"]').setAttribute('href', config.theme.favicon);
    document.querySelector('link[rel="apple-touch-icon"]').setAttribute('href', config.theme.favicon);
}



const loadRis = async () => {
    const res = await fetch('/configuration.json')
    const config = await res.json()
    window.AppSettings = {
        ...config
    }

    await init('ris')

    ReactDOM.render(
        <App />,
        document.getElementById('root')
    );
}

// loadPatient()
loadRis()